<svelte:options tag={null} />
<script>
  import { get_current_component } from "svelte/internal";
  import "@everymatrix/em-accordion";

  export let success = false;
  export let error;
  let validationError;

  let periods = [
    'SelfExclusionFor30Days', 
    'SelfExclusionFor3Months', 
    'SelfExclusionFor6Months', 
    'SelfExclusionFor1Year',
    'SelfExclusionPermanent',
  ];

  let limits = {
    period: '',
    sendNotificationEmail: false,
    expiryDate: '',
    selfExclusionReason: ''
  }

  const thisComponent = get_current_component();

  const dispatchWcEvent = (name, detail) => {
    thisComponent.dispatchEvent(
      new CustomEvent(name, {
        detail,
        composed: true, // propagate across the shadow DOM
      })
    );
  };

  function formatDate(date) {
    if (date === '') {
      return '';
    } else {
      let format = new Date(date).toISOString();
      return format;
    }
  }

  const handleData = (list) => {
    validationError = null;
    
    if (list.period === '') {
      validationError = "Must have a period selected";
      return;
    } else if (list.period === 'SelfExclusionUntilSelectedDate' && list.expiryDate === '') {
      validationError = "Must select an expiry date";
      return;
    } else {
      // Reset Selections
      limits = {
        period: '',
        sendNotificationEmail: false,
        expiryDate: '',
        selfExclusionReason: ''
      }
      // Format expiry date
      list.expiryDate && 
        list.expiryDate.length > 0 ? 
        list.expiryDate = formatDate(list.expiryDate) : 
        null
      ;
      // Check for unselected expiry date
      list.expiryDate === '' ? delete list.expiryDate : null;
      // Send Custom Event
      dispatchWcEvent("change", { "selfExclusion": list });
    }
  };
</script>


<div class="accordion">
  <em-accordion>
    <!-- Title -->
    <h3 slot="title" class="accordion__title">
      Self Exclusion
    </h3>
    <!-- Content -->
    <div slot="content" class="accordion__content">
      <!-- Self Exclusion Period -->
      {#each periods as period}
        <!-- Limit Name -->
        <label class="selectWrapper">
          <input
            class="radio"
            type=radio
            bind:group={limits.period}
            value="{period}"
          />
          <span>
            {period.match(/[A-Z][a-z]+|[0-9]+/g).join(" ")}
          </span>
        </label>
      {/each}
      <div style="margin-bottom: 30px;">
        <label class="selectWrapper">
          <input
            class="radio"
            type=radio
            bind:group={limits.period}
            value="SelfExclusionUntilSelectedDate"
          />
          <span>
            Self Exclusion Until Selected Date
          </span>
        </label>
        <!-- Self Exclusion Period Date -->
        {#if limits.period === 'SelfExclusionUntilSelectedDate'}
          <label class="inputWrapper">
            <input
              class="input"
              type="date" 
              name=""
              bind:value="{limits.expiryDate}"
            >
          </label>
        {/if}
      </div>
      <!-- Send Notification Email -->
      <label class="selectWrapper" style="margin-bottom: 30px;">
        <input
          class="checkbox"
          type=checkbox
          bind:checked={limits.sendNotificationEmail}
          value=""
        >
        <span>
          Send Notification Email
        </span>
      </label>
      <!-- Self Exclusion Reason -->
      <div class="inputWrapper">
        <span style="display: block; margin-bottom: 10px;">
          Self Exclusion Reason
        </span>
        <label class="selectWrapper">
          <input
            class="radio"
            type=radio
            bind:group={limits.selfExclusionReason}
            value="OtherBrands"
          />
          <span>
            Other Brands
          </span>
        </label>
        <label class="selectWrapper">
          <input
            class="radio"
            type=radio
            bind:group={limits.selfExclusionReason}
            value="UserRequest"
          />
          <span>
            User Request
          </span>
        </label>
      </div>
      {#if validationError}
        <p style="color: red;">
          You must add a period and a reason
        </p>
      {/if}
      {#if success?.hasOwnProperty('selfExclusion')}
        <p style="color: green;">
          Limit saved succesfully
        </p>
      {/if}
      {#if error && error.includes('SelfExclusion')}
        <p style="color: red;">
          Something went wrong with the request
        </p>
      {/if}
      <!-- Save Button -->
      <button
        class="button" 
        on:click={() => handleData(limits)}
      >
        Save
      </button>
    </div>
  </em-accordion>
</div>


<style lang="scss">
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    list-style: none;
    outline: none;
    text-decoration: none;
    box-sizing: border-box;
    font-family: "Helvetica Neue", "Helvetica", sans-serif;
  }
  .accordion {
    margin-bottom: 10px;

    &__content {
      display: flex;
      flex-direction: column;
    }
  }

  .selectWrapper {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-weight: bold;
    cursor: pointer;
    &:last-child { margin-bottom: 0; }
    span { 
      margin-left: 10px;
      font-size: 12px;
    }
  }

  .inputWrapper {
    margin-bottom: 10px;
    span { font-weight: bold; }
  }

  .input {
    max-width: 50%;
    padding: 5px 10px;
    margin-right: 10px;
  }

  .button {
    display: block;
    width: 150px;
    margin: 20px auto 0 auto;
    min-height: 30px;
    padding: 6px 7px;
    color: #fff;
    background: #307fe2;
    border: 1px solid #307fe2;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 16px;
    &:hover {
      background: #000;
      border: 1px solid #000;
    }
  }
</style>
